import script from "./BackgroundImages.vue?vue&type=script&lang=ts&setup=true"
export * from "./BackgroundImages.vue?vue&type=script&lang=ts&setup=true"

import "./BackgroundImages.vue?vue&type=style&index=0&id=493f0bf5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-493f0bf5"]])

export default __exports__